import { render, staticRenderFns } from "./GridResponsiveGrids.vue?vue&type=template&id=63d240d2&"
import script from "./GridResponsiveGrids.vue?vue&type=script&lang=js&"
export * from "./GridResponsiveGrids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports